import { takeLatest, put } from 'redux-saga/effects'
import { createReducer, makeAction, makeKeys, urlWithPrefix } from './helper'
import { httpPost, httpGet, httpPut } from 'core/restClient'
import { appLoading, appLoaded, toastError, toastSuccess, toastWarning } from './app'
import { purchaseOrderPath, purchaseOrderDetailPath, purchaseOrderEditPath, homePath } from 'routes'
import { lower } from 'change-case'

import r from 'reactotron-react-js'

const FETCH_PO = makeKeys('FETCH_PO')
const GET_PO_DETAIL = makeKeys('GET_PO_DETAIL')
const GET_PO_APPROVER = makeKeys('GET_PO_APPROVER')
const APPROVER_PO_ACTION = makeKeys('APPROVER_PO_ACTION')
const UNLOCK_PO_SAP = 'UNLOCK_PO_SAP'
const RELOAD_PO_SAP = makeKeys('RELOAD_PO_SAP')
const GET_VENDOR_STATUS = makeKeys('GET_VENDOR_STATUS')
const UPDATE_PO = 'UPDATE_PO'
const SUBMIT_PO = 'SUBMIT_PO'
const RESUBMIT_PO = 'RESUBMIT_PO'
const RESUBMIT_TO_VENDOR_PO = 'RESUBMIT_TO_VENDOR_PO'
const GET_PO_ERROR_WORKFLOW = makeKeys('GET_PO_ERROR_WORKFLOW')
const UPDATE_PO_ATTACHMENT = makeKeys('UPDATE_PO_ATTACHMENT')

export const fetchPo = makeAction(FETCH_PO.REQUEST, 'query')
export const getPoDetail = makeAction(GET_PO_DETAIL.REQUEST, 'id', 'history', 'isDetail')
export const getPoApprover = makeAction(GET_PO_APPROVER.REQUEST, 'id')
export const approverPOAction = makeAction(APPROVER_PO_ACTION.REQUEST, 'data', 'history')
export const unlockPoSAP = makeAction(UNLOCK_PO_SAP, 'sapNo')
export const reloadPoSAP = makeAction(RELOAD_PO_SAP.REQUEST, 'poId')
export const getVendorStatus = makeAction(GET_VENDOR_STATUS.REQUEST, 'vendorCode')
export const updatePO = makeAction(UPDATE_PO, 'data', 'history')
export const submitPO = makeAction(SUBMIT_PO, 'data', 'history')
export const resubmitPO = makeAction(RESUBMIT_PO, 'data', 'history')
export const resubmitToVendorPO = makeAction(RESUBMIT_TO_VENDOR_PO, 'data', 'history')
export const getPOErrorWorkFlow = makeAction(GET_PO_ERROR_WORKFLOW.REQUEST, 'procInstID', 'subProcInstID')
export const updatePoAttachment = makeAction(UPDATE_PO_ATTACHMENT.REQUEST, 'id', 'data', 'onSuccess')

const fetchPoSuccess = makeAction(FETCH_PO.SUCCESS, 'data')
const getPoDetailSuccess = makeAction(GET_PO_DETAIL.SUCCESS, 'data')
const getPoApproverSuccess = makeAction(GET_PO_APPROVER.SUCCESS, 'data')
const reloadPoSAPSuccess = makeAction(RELOAD_PO_SAP.SUCCESS, 'data')
const getVendorStatusSuccess = makeAction(GET_VENDOR_STATUS.SUCCESS, 'data')
const getPOErrorWorkFlowSuccess = makeAction(GET_PO_ERROR_WORKFLOW.SUCCESS, 'data')

const getPoApproverFailure = makeAction(APPROVER_PO_ACTION.FAILURE)

const poApiPath = path => path ? urlWithPrefix(`purchaseOrders/${path}`) : urlWithPrefix('purchaseOrders')
const multipartHeader = { 'Content-Type': 'multipart/form-data', }

const submit = (id) => poApiPath(`${id}/submit`)
const reSubmit = () => poApiPath(`reSubmit`)
const update = (id) => poApiPath(`${id}`)
const updateAttachments = (id) => poApiPath(`${id}/Attachments`)

const checkHasAttachments = (newAttachments) => {
  const result = { success: false, data: {} }
  if (newAttachments) {
    let key = Object.keys(newAttachments)
    if (key.length) {
      for (let i = 0; i < key.length; i++) {
        if (newAttachments[key[i]].length) {
          result.success = true
          result.data[key[i]] = newAttachments[key[i]]
        }
      }
    }
  }
  return result
}

function* uploadFile(id,data) {
  let fileCount = 0
  let countUploading = 1
  let fileName = ''
  try {
    Object.keys(data).forEach(x=>{
      let object = data[x]
      if(Array.isArray(object)){
        fileCount += object.length
      }
    })

    let keys = Object.keys(data)
    for(let i=0;i<keys.length;i++){
      let keyName = keys[i]
      let object = data[keyName]
      if(Array.isArray(object)){
        for(let ii=0;ii<object.length;ii++){
          let fileItem = object[ii]
          fileName = fileItem.path
          yield put(appLoading(`Uploading File '${fileItem.path}' (${countUploading}/${fileCount})`))
          let file = {}
          file[keyName] = [fileItem]
          yield httpPost(updateAttachments(id), file, multipartHeader)
          countUploading++
        }
      }
    }
  } catch (e) {
    throw {attachment:true, message:`Upload Attachments fail on '${fileName}' (${countUploading}/${fileCount})`}
  }
}

function* fetchPoRequest(action) {
  const { query } = action.payload
  let filter = JSON.parse(JSON.stringify(query.filter || {}))
  let key = query.search
  try {
    if (filter) {
      let vendor = filter.vendor ? filter.vendor.split(':') : []
      if (vendor.length > 0) {
        filter.vendorCode = vendor[0] ? vendor[0].trim() : null
        filter.vendorName = vendor[1] ? vendor[1].trim() : null
      }
      //set project
      let p = ''
      if (filter.projectId && Array.isArray(filter.projectId)) {
        filter.projectId.forEach(i => {
          p += ',' + i
        })
        p = p.substring(1)
        filter.projectId = p
      }
    }
    yield put(appLoading('Loading Purchase Orders.'))
    const response = yield httpGet(poApiPath(), { ...filter, key: key ? key.key : '', page: query.page, size: query.size })
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(fetchPoSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(appLoaded())

    if (e && e.config && e.config.headers && e.config.headers.Authorization === 'Bearer null') {
      yield put(fetchPo(query))
    } else {
      if (e && e.data && e.data.message) {
        yield put(toastError(e.data.message))
      } else {
        yield put(toastError('Load purchase orders data error!'))
      }
    }
  }
}

function* getPoDetailRequest(action) {
  const { id, history, isDetail } = action.payload
  try {
    yield put(appLoading('Loading Purchase Order.'))
    const username = localStorage.getItem('username').toLowerCase()
    const response = yield httpGet(poApiPath(`${id}`))
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        const data = response.data
        let createdUser = lower(data.createdUser)
        let requesterUser = lower(data.requesterUser)
        let procurementReviewer = lower(data.procurementReviewer)
        yield put(appLoaded())
        if (data.status == 5 || data.status == 0) {
          // if(data.sn||requesterUser.includes(username)||createdUser.includes(username)||procurementReviewer.includes(username)||lower(data.requesterUser)==username||lower(data.createdUser)==username||lower(data.procurementReviewer)==username){
          if (data.sn || requesterUser.includes(username) || createdUser.includes(username) || lower(data.requesterUser) == username || lower(data.createdUser) == username) {
            if (isDetail) {
              history.push(purchaseOrderEditPath(data.id))
            } else {
              yield put(getPoDetailSuccess(response.data))
            }
          } else {
            if (isDetail) {
              yield put(getPoDetailSuccess(response.data))
            } else {
              history.push(purchaseOrderDetailPath(data.id))
            }
          }
        } else {
          if (isDetail) {
            yield put(getPoDetailSuccess(response.data))
          } else {
            history.push(purchaseOrderDetailPath(data.id))
          }
        }
      }
    }
  } catch (e) {
    yield put(appLoaded())
    if (e && e.config && e.config.headers && e.config.headers.Authorization === 'Bearer null') {
      yield put(getPoDetail(id))
    } else {
      if (e && e.data && e.data.message) {
        yield put(toastError(e.data.message))
      } else {
        yield put(toastError('Load purchase order data error!'))
      }
    }
  }
}

function* getPoApproverRequest(action) {
  const { id } = action.payload
  try {
    const response = yield httpGet(poApiPath(`${id}/goaApprover`))
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getPoApproverSuccess(response.data))
      }
    }
  } catch (e) {
    if (e && e.config && e.config.headers && e.config.headers.Authorization === 'Bearer null') {
      yield put(getPoApprover(id))
    } else {
      yield put(getPoApproverFailure())
      if (e && e.data && e.data.message) {
        yield put(toastError(e.data.message))
      } else {
        yield put(toastError('Load purchase order approver error!'))
      }
    }
  }
}

function* approverPOActionRequest(action) {
  const { data, history } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpPost(poApiPath(`${data.docId}/actionApproval`), data, multipartHeader)
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data.success) {
        if (history.location.search.includes('h=true')) {
          history.push(homePath)
        } else {
          history.push(purchaseOrderPath)
        }
        yield put(toastSuccess('Purchase order action success'))

        if (response.data.warningMessages && response.data.warningMessages.length) {
          var warnMsg = response.data.warningMessages[0] || ''
          if (warnMsg) {
            yield put(toastWarning(warnMsg))
          }
        }
      }
    }
  } catch (e) {
    yield put(appLoaded())
    if (e.data && e.data.message){
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Purchase order action fail.'))
    }
  }
}

function* unlockPoSAPRequest(action) {
  const { sapNo } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpGet(poApiPath(`unlock/${sapNo}`))
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      yield put(toastSuccess('Purchase order unlock success.'))
    }
  } catch (e) {
    yield put(appLoaded())
    yield put(toastError('Purchase order unlock fail. (I)'))
  }
}

function* reloadPoSAPRequest(action) {
  const { poId } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpGet(poApiPath(`${poId}/reload`))
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      yield put(reloadPoSAPSuccess(response.data))
      yield put(toastSuccess('Reload SAP data success.'))
    }
  } catch (e) {
    yield put(appLoaded())
    yield put(toastError('Reload SAP data fail.'))
  }
}

function* getVendorStatusRequest(action) {
  const { vendorCode } = action.payload
  try {
    const response = yield httpGet(`vendors/${vendorCode}/status`)
    if (response.status >= 200 && response.status < 300) {
      yield put(getVendorStatusSuccess(response.data))
    }
  } catch (e) {
  }
}

function* updatePORequest(action) {
  const { data, history } = action.payload
  try {
    yield put(appLoading())
    const response1 = yield httpPut(update(data.id), data)
    if (response1.status >= 200 && response1.status < 300) {
      const attachments = checkHasAttachments(data.newAttachments)
      // const response2 = attachments.success ? yield httpPost(updateAttachments(data.id), attachments.data, multipartHeader) : { status: 200 }
      // if (response2.status >= 200 && response2.status < 300) {
      //   yield put(appLoaded())
      //   history.push(purchaseOrderPath)
      // }
      if(attachments.success){
        yield uploadFile(data.id, attachments.data)
      }
      yield put(appLoaded())
      history.push(purchaseOrderPath)
      
    }
  } catch (e) {
    yield put(appLoaded())
    r.log(e)
    if(e.attachment){
      yield put(toastError(e.message,true))
    }else if (e.data) {
      yield put(toastError(e.data.message))
    }
  }
}

function* submitPORequest(action) {
  const { data, history } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpGet(poApiPath(`${data.id}/preSubmit`))
    if (response.status >= 200 && response.status < 300) {
      if (response.data.success) {
        const response1 = yield httpPut(update(data.id), data)
        if (response1.status >= 200 && response1.status < 300) {
          const attachments = checkHasAttachments(data.newAttachments)
          // const response2 = attachments.success ? yield httpPost(updateAttachments(data.id), attachments.data, multipartHeader) : { status: 200 }
          // if (response2.status >= 200 && response2.status < 300) {
          //   const response3 = yield httpPost(submit(data.id))
          //   if (response3.status >= 200 && response3.status < 300) {
          //     yield put(appLoaded())
          //     history.push(purchaseOrderPath)
          //   }
          // }
          if(attachments.success){
            yield uploadFile(data.id, attachments.data)
          }
          const response3 = yield httpPost(submit(data.id))
          if (response3.status >= 200 && response3.status < 300) {
            yield put(appLoaded())
            history.push(purchaseOrderPath)
          }          
        }
      } else {
        yield put(appLoaded())
        yield put(toastError(response.data.message))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    if (e.data) {
      yield put(toastError(e.data.message))
    }
  }
}

function* resubmitPORequest(action) {
  const { data, history } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpGet(poApiPath(`${data.id}/preSubmit`))
    if (response.status >= 200 && response.status < 300) {
      if (response.data.success) {
        const response1 = yield httpPut(update(data.id), data)
        if (response1.status >= 200 && response1.status < 300) {
          const attachments = checkHasAttachments(data.newAttachments)          
          // const response2 = attachments.success ? yield httpPost(updateAttachments(data.id), attachments.data, multipartHeader) : { status: 200 }
          // if (response2.status >= 200 && response2.status < 300) {
          //   const response3 = yield httpPost(reSubmit(), {
          //     docId: data.id,
          //     sn: data.sn,
          //     action: data.actionName,
          //     comment: data.actionComment
          //   })
          //   if (response3.status >= 200 && response3.status < 300) {
          //     yield put(appLoaded())
          //     history.push(purchaseOrderPath)
          //   }
          // }
          if(attachments.success){
            yield uploadFile(data.id, attachments.data)
          }
          const response3 = yield httpPost(reSubmit(), {
            docId: data.id,
            sn: data.sn,
            action: data.actionName,
            comment: data.actionComment
          })
          if (response3.status >= 200 && response3.status < 300) {
            yield put(appLoaded())
            history.push(purchaseOrderPath)
          }
        }
      } else {
        yield put(appLoaded())
        yield put(toastError(response.data.message))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    if (e.data) {
      yield put(toastError(e.data.message))
    }
  }
}

function* resubmitToVendorPORequest(action) {
  const { data, history } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpGet(poApiPath(`${data.id}/preResubmitToVendor`))
    if (response.status >= 200 && response.status < 300) {
      if (response.data.success) {
        const response1 = yield httpPut(update(data.id), data)
        if (response1.status >= 200 && response1.status < 300) {
          const attachments = checkHasAttachments(data.newAttachments)
          // const response2 = attachments.success ? yield httpPost(updateAttachments(data.id), attachments.data, multipartHeader) : { status: 200 }
          // if (response2.status >= 200 && response2.status < 300) {
          //   const response3 = yield httpPost(poApiPath(`${data.id}/actionApproval`), {
          //     docId: data.id,
          //     sn: data.sn,
          //     action: data.actionName,
          //     comment: data.actionComment
          //   }, multipartHeader)
          //   if (response3.status >= 200 && response3.status < 300) {
          //     yield put(appLoaded())
          //     history.push(purchaseOrderPath)
          //   }
          // }
          if(attachments.success){
            yield uploadFile(data.id, attachments.data)
          }
          const response3 = yield httpPost(poApiPath(`${data.id}/actionApproval`), {
            docId: data.id,
            sn: data.sn,
            action: data.actionName,
            comment: data.actionComment
          }, multipartHeader)
          if (response3.status >= 200 && response3.status < 300) {
            yield put(appLoaded())
            history.push(purchaseOrderPath)
          }
        }
      } else {
        yield put(appLoaded())
        yield put(toastError(response.data.message))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    if (e.data) {
      yield put(toastError(e.data.message))
    }
  }
}

function* getPOErrorWorkFlowRequest(action) {
  const { procInstID, subProcInstID } = action.payload
  try {
    const response = yield httpGet(`share/workflow/getErrorWorkflow`, { procInstID: procInstID, subProcInstID: subProcInstID })
    if (response.status >= 200 && response.status < 300) {
      if (response.data.success) {
        yield put(getPOErrorWorkFlowSuccess({ isError: false, msg: '' }))
      } else {
        yield put(getPOErrorWorkFlowSuccess({ isError: true, msg: response.data.message }))
      }
    }
  } catch (e) {
    yield put(getPOErrorWorkFlowSuccess({ isError: false, msg: '' }))
  }
}

function* updatePoAttachmentRequest(action) {
  const { id, data, onSuccess } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpPost(poApiPath(`${id}/updateAttachment`), data, multipartHeader)
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data.success) {
        if (onSuccess) {
          onSuccess()
        }
        yield put(toastSuccess('Update PO attachment success'))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    yield put(toastError('Purchase order action fail.'))
  }
}

export function* watchPurchaseOrderSaga() {
  yield takeLatest(FETCH_PO.REQUEST, fetchPoRequest)
  yield takeLatest(GET_PO_DETAIL.REQUEST, getPoDetailRequest)
  yield takeLatest(GET_PO_APPROVER.REQUEST, getPoApproverRequest)
  yield takeLatest(APPROVER_PO_ACTION.REQUEST, approverPOActionRequest)
  yield takeLatest(UNLOCK_PO_SAP, unlockPoSAPRequest)
  yield takeLatest(RELOAD_PO_SAP.REQUEST, reloadPoSAPRequest)
  yield takeLatest(GET_VENDOR_STATUS.REQUEST, getVendorStatusRequest)
  yield takeLatest(UPDATE_PO, updatePORequest)
  yield takeLatest(SUBMIT_PO, submitPORequest)
  yield takeLatest(RESUBMIT_PO, resubmitPORequest)
  yield takeLatest(RESUBMIT_TO_VENDOR_PO, resubmitToVendorPORequest)
  yield takeLatest(GET_PO_ERROR_WORKFLOW.REQUEST, getPOErrorWorkFlowRequest)
  yield takeLatest(UPDATE_PO_ATTACHMENT.REQUEST, updatePoAttachmentRequest)
}

const initial = {
  listPo: { data: {}, loading: false },
  poDetail: { data: {}, loading: false },
  approvers: { data: [], loading: false },
  poSAPData: { data: {}, loading: false },
  vendorStatus: {},
  k2workFlowError: { isError: false, msg: '' },
}

export default createReducer(initial, state => ({
  [FETCH_PO.REQUEST]: () => ({
    ...state,
  }),
  [FETCH_PO.SUCCESS]: (data) => ({
    ...state,
    listPo: { data: data.data, loading: false }
  }),
  [GET_PO_DETAIL.REQUEST]: () => ({
    ...state,
    poDetail: { data: {}, loading: true }
  }),
  [GET_PO_DETAIL.SUCCESS]: (data) => ({
    ...state,
    poDetail: { data: data.data, loading: false }
  }),
  [GET_PO_APPROVER.REQUEST]: () => ({
    ...state,
    approvers: { data: [], loading: true }
  }),
  [GET_PO_APPROVER.SUCCESS]: (data) => ({
    ...state,
    approvers: { data: data.data, loading: false }
  }),
  [GET_PO_APPROVER.FAILURE]: () => ({
    ...state,
    approvers: { data: [], loading: false }
  }),
  [RELOAD_PO_SAP.REQUEST]: () => ({
    ...state,
    poSAPData: { data: {}, loading: true }
  }),
  [RELOAD_PO_SAP.SUCCESS]: (data) => ({
    ...state,
    poSAPData: { data: data.data, loading: false }
  }),
  [GET_VENDOR_STATUS.REQUEST]: () => ({
    ...state,
    vendorStatus: {}
  }),
  [GET_VENDOR_STATUS.SUCCESS]: (data) => ({
    ...state,
    vendorStatus: { ...data.data }
  }),
  [GET_PO_ERROR_WORKFLOW.REQUEST]: () => ({
    ...state,
    k2workFlowError: { isError: false, msg: '' },
  }),
  [GET_PO_ERROR_WORKFLOW.SUCCESS]: (data) => ({
    ...state,
    k2workFlowError: { isError: data.data.isError, msg: data.data.msg },
  }),
}))